export enum ListingOptionsActionTypes {
  GET_EVENT_TYPES = 'GET_EVENT_TYPES',
  STORE_EVENT_TYPES = 'STORE_EVENT_TYPES',
  GET_OBJECT_TYPES = 'GET_OBJECT_TYPES',
  STORE_OBJECT_TYPES = 'STORE_OBJECT_TYPES',
  GET_OBJECT_CHARACTERISTICS = 'GET_OBJECT_CHARACTERISTICS',
  STORE_OBJECT_CHARACTERISTICS = 'STORE_OBJECT_CHARACTERISTICS',
  GET_OFFER_FEATURES = 'GET_OFFER_FEATURES',
  STORE_OFFER_FEATURES = 'STORE_OFFER_FEATURES',
}
